import React, { Component } from 'react'
import { connect } from "react-redux"

import { Card, CardBody, CardHeader, Col, Row, Button } from 'reactstrap'
import {ToastSuccess, ToastDanger} from 'react-toastr-basic'

import Table from '../table/Table'
import ModalButton from '../modal-button/ModalButton'
import StatusBadge from '../status-badge/StatusBadge'
import Date from '../date/Date'
import SpreadsheetForm from './SpreadsheetForm'

import {services} from '../../../js/services/index'
import {deleteMigration} from '../../../js/firebase/firebase-manager'
import {migrationEntityActions, migrationListActions} from '../../../js/actions/index'
import {getEnvironmentLabel} from '../../../helpers/environment/environment-helper'

class SpreadsheetMigration extends Component {
    state = {
        headers: ["Namespace", "Processos", "Contatos sem processo", "Inicio", "Fim", "Ambiente", "Status", ""],
        defaultValues: {
            ORIGIN: 'SPREADSHEET',
            NAME: 'Planilha'
        }
    }

    getRows = () => {
        return this.props.list.map((migration, index) => 
            <tr key={index}>
                <td>{migration.namespace}</td>
                <td>{migration.folders}</td>
                <td>{migration.contacts}</td>
                <td>{<Date value={migration.start}/>}</td>
                <td>{<Date value={migration.end}/>}</td>
                <td>{getEnvironmentLabel(migration.environment)}</td>
                <td><StatusBadge status={migration.status} text={migration.errorStacktrace}></StatusBadge></td>
                <td>{this.deleteMigrationButton(migration)}</td>
            </tr>)
    }

    deleteMigrationButton = migration => {
        return <ModalButton 
            buttonLabel={<i className="fa fa-trash"/>}
            title="Excluir registro de migração"
            className="modal-lg"
            color="link"
            confirm={closeModal => this.deleteMigration(migration, closeModal)}
        >
            <p>Deseja realmente excluir o registro da migração {migration.namespace}?</p>
        </ModalButton>
    }

    deleteMigration = (migration, closeModal) => {
        deleteMigration(migration.id)
            .then(closeModal)
    }

    handleNewMigrationChange = (key, value) => {
        this.props.update({[key]: value})
    }

    startNewMigration = (closeModal) => {
        services.startSpreadsheetMigration({...this.props.newMigration, 'origin': this.state.defaultValues.ORIGIN})
            .then(() => ToastSuccess('Sucesso! Migração iniciada.'))
            .catch(() => ToastDanger('Erro ao iniciar migração.'))
            .finally(() => this.clerNewMigration(closeModal))
    }

    clerNewMigration = closeModal => {
        this.props.clear()
        closeModal()
    }

    showAll = () => {
        this.props.showAll()
        this.setState({...this.state, showingAll: true})
    }

    render() {
        return (
            <div className="animated fadeIn">
                <Card>
                    <CardHeader>
                        <Row>
                            <Col xs="8" lg="10">
                                <div className="card-title">
                                    <i className="fa fa-align-justify"></i> Migrações {this.state.defaultValues.NAME}
                                </div>
                            </Col>
                            <Col xs="4" lg="2">
                                <ModalButton 
                                    buttonLabel="Adicionar"
                                    title={`Adicionar nova migração ${this.state.defaultValues.NAME}` }
                                    className="modal-lg"
                                    color="primary"
                                    confirm={this.startNewMigration}
                                    cancel={this.clerNewMigration}
                                >
                                    <SpreadsheetForm 
                                        handleChange={this.handleNewMigrationChange} 
                                        entity={this.props.newMigration}/>
                                </ModalButton>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Table headers={this.state.headers} getRows={this.getRows}/>
                        {
                            !this.state.showingAll ? 
                            <Button block color="link" type="button" onClick={this.showAll}>
                                Mostrar todas
                            </Button>
                            :null
                        }
                    </CardBody>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        newMigration: state.migrationEntityReducer.entity,
        list: state.migrationsListReducer.spreadsheet.filtered
    }
}

const mapDispatchToProps = dispatch => {
    return {
        update: migrationEntity => dispatch(migrationEntityActions.updateMigrationEntity(migrationEntity)),
        clear: () => dispatch(migrationEntityActions.clearMigrationEntity()),
        showAll: () => dispatch(migrationListActions.showAllSpreadsheetMigrations())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SpreadsheetMigration);


// WEBPACK FOOTER //
// ./src/views/components/spreadsheet/SpreadsheetMigration.js